// extracted by mini-css-extract-plugin
export default {"wrapper":"RippleElement_wrapper__4uroa","ripple":"RippleElement_ripple__R9uRs"};